var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBrucke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8721 1.34131L13.1426 1.34131L13.1426 14.8765C13.1426 15.2964 13.2891 15.6528 13.582 15.9458C13.875 16.2388 14.2314 16.3853 14.6514 16.3853C15.0615 16.3853 15.4082 16.2437 15.6914 15.9605L19.5 12.1519L19.5 15.1548L12 22.6548L4.5 15.1548L4.5 12.1519L8.32324 15.9604C8.60644 16.2437 8.95312 16.3853 9.36328 16.3853C9.7832 16.3853 10.1396 16.2388 10.4326 15.9458C10.7256 15.6528 10.8721 15.2964 10.8721 14.8765L10.8721 1.34131Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBrucke);
export default __webpack_public_path__ + "static/media/arrow-down-brucke.a61ce4d6ebac36b79b86768a39af40c7.svg";
export { ForwardRef as ReactComponent };